import { SizeGuideTable } from "@made-people/blueprint-size-guide-table";
import { ComponentWrapper } from "@made-people/blueprint-component-wrapper";
import { ComponentProps } from "react";

type SizeGuideTableProps = ComponentProps<typeof SizeGuideTable>;

export const SizeGuideTableStoryblok = (props: SizeGuideTableProps) => {
  return (
    <ComponentWrapper layout={{ position: { maxWidth: "none" } }}>
      <div className="mx-auto max-w-[800px]">
        <SizeGuideTable {...props} />
      </div>
    </ComponentWrapper>
  );
};
